import React from "react";
import { useFormContext } from "react-hook-form";
import { Mask } from "../../util.js";
import useIsMobile from "../../hooks/useIsMobile.js";
import usePageTracking from "../pageTracking.jsx";

const StepDadosCliente = () => {
  const isMobile = useIsMobile();
  const {
    register,
    formState: { errors },
  } = useFormContext();
  usePageTracking();

  return (
    <>
      <div className="text-center">
        <h3 className="mb-3">
          <b>1º Passo:</b> Sobre você.
        </h3>
        <p className="mb-3">Dê mais detalhes sobre você.</p>
      </div>

      <div className="row g-3">
        <div className={isMobile ? "" : "col-2"}></div>
        <div className={isMobile ? "col-12" : "col-4"}>
          <div className="row mb-1">
            <div className="col-12">
              <div className="form-floating">
                <input
                  id="edtNome"
                  placeholder="Nome"
                  className={`form-control ${errors.nome ? "is-invalid" : ""}`}
                  {...register("nome", { required: "Nome é obrigatório" })}
                />
                <label htmlFor="edtNome">Nome</label>
                {errors.nome && (
                  <div className="invalid-feedback">{errors.nome.message}</div>
                )}
              </div>
            </div>
          </div>

          <div className="row mb-1">
            <div className="col-12">
              <div className="form-floating">
                <input
                  id="edtSobrenome"
                  placeholder="Sobrenome"
                  className={`form-control ${
                    errors.sobrenome ? "is-invalid" : ""
                  }`}
                  {...register("sobrenome", {
                    required: "Sobrenome é obrigatório",
                  })}
                />
                <label htmlFor="edtSobrenome">Sobrenome</label>
                {errors.sobrenome && (
                  <div className="invalid-feedback">
                    {errors.sobrenome.message}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="form-floating">
                <input
                  id="edtEmail"
                  placeholder="Email"
                  className={`form-control ${errors.email ? "is-invalid" : ""}`}
                  {...register("email", {
                    required: "Email é obrigatório",
                    pattern: {
                      value: /^\S+@\S+$/i,
                      message: "Formato de email inválido",
                    },
                  })}
                />
                <label htmlFor="edtEmail">Email</label>
                {errors.email && (
                  <div className="invalid-feedback">{errors.email.message}</div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className={isMobile ? "col-12 mt-1" : "col-4"}>
          <div className="row mb-1">
            <div className="col-12">
              <div className="form-floating">
                <input
                  id="edtCelular"
                  type="tel"
                  placeholder="Celular"
                  onInput={(e) =>
                    (e.target.value = Mask.telefone(e.target.value))
                  }
                  className={`form-control ${
                    errors.celular ? "is-invalid" : ""
                  }`}
                  {...register("celular", {
                    required: "Celular é obrigatório",
                  })}
                />
                <label htmlFor="edtCelular">Celular</label>
                {errors.celular && (
                  <div className="invalid-feedback">
                    {errors.celular.message}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="form-floating">
                <input
                  id="edtDataNascimento"
                  type="date"
                  className={`form-control ${
                    errors.dataNascimento ? "is-invalid" : ""
                  }`}
                  {...register("dataNascimento", {
                    required: "Data de nascimento é obrigatória",
                  })}
                />
                <label htmlFor="edtDataNascimento">Data de nascimento</label>
                {errors.dataNascimento && (
                  <div className="invalid-feedback">
                    {errors.dataNascimento.message}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className={isMobile ? "" : "col-2"}></div>
      </div>
    </>
  );
};

export default StepDadosCliente;
